
import http from "../http-common";

class LolService {
  getAll() {
    return http.get("/lols");
  }

  getCustomerLols(customerID) {
    return http.get(`/lols/?customerid=${customerID}`);
  }

  getLocationLols(locationID) {
    return http.get(`/lols/?locationid=${locationID}`);
  }

  get(lolID) {
    return http.get(`/lols/${lolID}`);
  }

  create(data) {
    return http.post("/lols", data);
  }

  update(lolID, data) {
    return http.put(`/lols/${lolID}`, data);
  }

  delete(lolID) {
    return http.delete(`/lols/${lolID}`);
  }

  deleteAll() {
    return http.delete(`/lols`);
  }

  findByName(lolNumber) {
    return http.get(`/lols?lolnumber=${lolNumber}`);
  }
}

export default new LolService();